import { createAction, props } from '@ngrx/store';

import { Employee } from 'app/shared/features/employee-selector/models';

export const updateEmployees = createAction(
    '[Employee] Update Employees',
    props<{ employeeList: Employee[] }>(),
);
